module.exports = __webpack_public_path__ + "assets/img/icon_user6.44fc8507.png";